import React, { Key, useEffect } from 'react';
import s from './SelectFilter.module.less';
import { FilterComponentProps, FilterHeaderComponentProps, PopoverFilterProps } from '../../filters';
import { observer } from 'mobx-react';
import { ISelectFilterStore, SelectFilterWidget } from '@custis/common';

interface Props extends FilterComponentProps<Key[]>, FilterHeaderComponentProps<Key[]>, PopoverFilterProps {
  store: ISelectFilterStore<Key>;
  id: string;
  mode?: 'multiple' | 'single';
  emptyOption?: boolean;
  emptyLabel?: string;
  dynamicWidth?: boolean;
}

export const SelectFilter = observer((props: Props) => {
  const { store, value, setValue, id, mode, emptyOption, emptyLabel, dynamicWidth = true } = props;

  useEffect(() => {
    if (value) {
      store.selectedValues = value;
      void store.loadOnMount();
    } else {
      store.selectedValues = [];
    }
  }, [value]);

  useEffect(() => {
    if (setValue) {
      setValue(store.selectedValues);
    }
  }, [store.selectedValues]);

  return (
    <div className={s.SelectFilter}>
      <SelectFilterWidget
        id={id}
        store={store}
        mode={mode}
        dynamicWidth={dynamicWidth}
        defaultWidth={250}
        emptyOption={emptyOption}
        emptyLabel={emptyLabel}
      />
    </div>
  );
});
